import styled from 'styled-components';
import { darkgrey } from 'styles/Colors';

export const TeamName = styled.div``;

export const Title = styled.span`
  font-size: 13px;
  line-height: 12px;
  color: ${darkgrey};
`;
